/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react'
import PropTypes from 'prop-types'
import {css} from '@emotion/core'
import {createMarkup} from '../graphql/datoCmsDataFactory'

const Instructions = ({content, themeStyles, title, browserType}) => {
    return (
        <section>
            <div
                css={css`
                    max-width: 600px;
                    margin: 0 auto;

                    @media (max-width: 1100px) {
                        max-width: 700px;
                    }

                    h4,
                    h2,
                    p,
                    span {
                        color: ${themeStyles.primaryTextColor};
                    }
                    h4 {
                        margin-bottom: 2.5rem;
                        font-weight: 400;
                    }
                    h2 {
                        font-size: 2.5rem;
                        letter-spacing: 0.33px;
                        margin-bottom: 1rem;
                        font-weight: 600;
                    }

                    p {
                        &:not(:last-of-type) {
                            margin-bottom: 10px;
                        }
                    }
                `}
            >
                {title && <h2>{title}</h2>}
                {content[0].title && <h4>{content[0].title}</h4>}
                {content[0].body && <div dangerouslySetInnerHTML={createMarkup(content[0].body)} />}
                {content[0].instructions && (
                    <div
                        css={css`
                            img {
                                width: ${browserType === 'chrome' ? '130px' : '100%'};
                                margin-left: 1rem;
                                margin-bottom: ${browserType === 'chrome' ? '-20px' : '10px'};
                            }
                            ol {
                                padding: 0 1rem 1rem;
                                li {
                                    margin: 1rem 0;
                                }
                                li,
                                label,
                                strong,
                                b {
                                    color: ${themeStyles.primaryTextColor};
                                }
                            }
                            a,
                            u {
                                color: ${themeStyles.primaryTextColor};
                            }
                        `}
                    >
                        <p>{content[0].instructions.leadIn}</p>
                        <ol>
                            {content[0].instructions.steps.map((step, idx) => (
                                <li key={idx}>
                                    <span
                                        className={content[0].instructions.spanClass}
                                        style={content[0].instructions.spanStyles}
                                        dangerouslySetInnerHTML={createMarkup(step)}
                                    />
                                </li>
                            ))}
                        </ol>
                    </div>
                )}
            </div>
        </section>
    )
}

Instructions.propTypes = {
    content: PropTypes.array,
    themeStyles: PropTypes.object,
}

Instructions.defaultProps = {}

export default Instructions
